module.exports = __webpack_public_path__ + "static/media/leaf_1.912884fe.png";